import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessFleetMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-fleet-metadata/business-fleet-metadata.component.abstract';

@Component({
  selector: 'app-business-fleet-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, CustomDatePipe],
  templateUrl: './business-fleet-metadata-v2.component.html',
})
export class BusinessFleetMetadataV2Component extends BusinessFleetMetadataComponentAbstract {}
